export default "__VITE_ASSET__CIONyrso__"